import React from "react";
import { Helmet } from "react-helmet-async";

const SeoHelmet = ({ title, description, keywords }) => {
  return (
    <Helmet>
      <title>{title || "Bhavana Singh | Personality Transformation Coach"}</title>
      <meta
        name="description"
        content={description || "Hi, I'm Bhavana Singh! I am a personality Transformation Coach who helps you shine and be the best version of yourself."}
      />
      <meta name="keywords" content={keywords || "Personal Transformation Coach, personality coach fashion coach"} />
    </Helmet>
  );
};

export default SeoHelmet;
